import envConfig from "../config";

/**
 * Sends a forgot-password recovery email via the public OLIVS users API.
 * @returns {Promise<{ isEmailSent: boolean }>}
 */
export async function sendForgotPasswordEmail(loginEmail, recaptchaToken) {
  const response = await fetch(
    `https://${envConfig.apiDev1}/api/v3/en-au/users/send-forgot-user-password-email?LoginEmail=${encodeURIComponent(loginEmail)}&BaseHostURL=${encodeURIComponent(envConfig.loginUrl)}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "olivs-api-real-ip": "115.70.37.103",
        "olivs-api-computer-name": "EC2AMAZ-QF1CQAD",
        "api-key": "OlivsAuth",
        captchav3: `${envConfig.loginUrl}:${recaptchaToken}`,
      },
    }
  );
  const data = await response.json();
  return {
    isEmailSent:
      data?.IsEmailSent === "Y" ||
      data?.IsEmailSent === true ||
      data?.SuccessYN === "Y",
  };
}
